import { getMattressFirmnessByBMI, getMattressFirmnessByErgonomicIndex } from "../../helpers";
import { Data, UserData } from "../../types/Data";
import { useStore } from "@/features/bed-configurator/store";

export function getRecommendationTexts (data: UserData) {
	const recommendations: string[] = [];

	const { bmi, score: ergonomicIndex, sleepPosition  } = data;

	const bmiFirmness = getMattressFirmnessByBMI(bmi),
		ergonomicIndexFirmness = getMattressFirmnessByErgonomicIndex(ergonomicIndex);

	const backSleeper = sleepPosition === 'auf dem Rücken',
		sideSleeper = sleepPosition === 'auf der Seite',
		stomachSleeper = sleepPosition === 'auf dem Bauch',
		switchingSleeper = sleepPosition === 'häufig wechselnd';

	if (bmiFirmness === 'h2') {

		if (ergonomicIndexFirmness === 'h2') {
			recommendations.push('Dein Körpergewicht ist im Verhältnis zu Deiner Größe eher gering bis normal. Daher benötigst Du eine vergleichsweise weichere Federung. So können gewisse Körperpartien trotzdem ausreichend tief in die Matratze einsinken, um eine optimale Wirbelsäulenposition zu gewährleisten.');
			
			switch (sleepPosition) {
				case 'auf der Seite':
					recommendations.push('Als Seitenschläfer sollte diese aus orthopädischen Gründen bei Dir eine horizontal waagerechte Linie parallel zur Matratze ergeben. Dazu muss die Matratze ausreichend weich genug sein.');
					break;
				case 'auf dem Rücken':
					recommendations.push('Als Rückenschläfer sollte diese aus orthopädischen Gründen bei Dir eine natürliche S-Form einnehmen. Die Matratze sollte für Rückenschläfer deswegen weder zu hart, noch zu weich sein.');
					break;
				case 'auf dem Bauch':
					recommendations.push('Als Bauchschläfer sollte diese aus orthopädischen Gründen bei Dir eine natürliche S-Form einnehmen. Die Matratze sollte für Bauchschläfer deswegen nicht zu weich sein.');
					break;
				case 'häufig wechselnd':
					recommendations.push('Als jemand, der häufiger seine Schlafposition wechselt, sollte Dein Körper ausreichend gut gestützt sein. Die Matratze darf weder zu hart noch zu weich sein.');
					break;
			}

			recommendations.push('Aufgrund Deines ergonomischen Härtegrad-Indexes ist für eine dauerhaft gesunde Schlafposition unser Härtegrad H2 die richtige Wahl für Dich - insbesondere, weil durch die 7-Zonen eine gute Druckverteilung gewährleistet ist.');

			recommendations.push(...addTendencies(data));

			return recommendations;
		}
		
		if (ergonomicIndexFirmness === 'h3') {
			recommendations.push('Dein Körpergewicht ist im Verhältnis zu Deiner Größe normal. Daher benötigst Du eine mittelfeste Federung. So können gewisse Körperpartien trotzdem ausreichend tief in die Matratze einsinken, um eine optimale Wirbelsäulenposition zu gewährleisten.');

			switch (sleepPosition) {
				case 'auf dem Rücken':
					recommendations.push('Als Rückenschläfer sollte diese aus orthopädischen Gründen bei Dir eine natürliche S-Form einnehmen. Die Matratze sollte für Rückenschläfer deswegen nicht zu weich sein.');
					break;
				case 'auf dem Bauch':
					recommendations.push('Als Bauchschläfer sollte diese aus orthopädischen Gründen bei Dir eine natürliche S-Form einnehmen. Die Matratze sollte für Bauchschläfer deswegen nicht zu weich sein.');
					break;
				case 'häufig wechselnd':
					recommendations.push('Als jemand, der häufiger seine Schlafposition wechselt, sollte Dein Körper ausreichend gut gestützt sein. Die Matratze deswegen nicht zu weich sein.');
					break;
			}

			recommendations.push('Aufgrund Deines ergonomischen Härtegrad-Indexes ist für eine dauerhaft gesunde Schlafposition unser Härtegrad H3 die richtige Wahl für Dich - insbesondere, weil durch die 7-Zonen eine gute Druckverteilung und gleichzeitig eine ausreichende Festigkeit gewährleistet ist.');

			recommendations.push(...addTendencies(data, [ '' ]));
	 
			return recommendations;
		}

		return recommendations;
	}
	
	if (bmiFirmness === 'h3') {

		if (ergonomicIndexFirmness === 'h2') {
			recommendations.push('Dein Körpergewicht ist im Verhältnis zu Deiner Größe normal. Aufgrund Deiner bevorzugten Schlafposition und Körperform solltest Du dennoch auf einer etwas weicheren Matratze schlafen, damit Körperpartien ausreichend tief in die Matratze einsinken können, um eine optimale Wirbelsäulenposition zu gewährleisten.');

			switch (sleepPosition) {
				case 'auf der Seite':
					recommendations.push('Als Seitenschläfer sollte diese aus orthopädischen Gründen bei Dir eine horizontal waagerechte Linie parallel zur Matratze ergeben. Dazu muss die Matratze ausreichend weich genug sein.');
					break;
			}

			recommendations.push('Aufgrund Deines ergonomischen Härtegrad-Indexes ist für eine dauerhaft gesunde Schlafposition unser Härtegrad H2 die richtige Wahl für Dich - insbesondere, weil durch die 7-Zonen eine gute Druckverteilung und gleichzeitig eine ausreichende Flexibilität gewährleistet ist.');

			recommendations.push(...addTendencies(data));

			return recommendations;
		}
		
		if (ergonomicIndexFirmness === 'h3') {
			recommendations.push('Dein Körpergewicht ist im Verhältnis zu Deiner Größe normal. Daher benötigst Du eine mittelfeste Federung. So können gewisse Körperpartien ausreichend tief in die Matratze einsinken, um eine optimale Wirbelsäulenposition zu gewährleisten.');

			if (sideSleeper) {
				recommendations.push('Als Seitenschläfer sollte diese aus orthopädischen Gründen bei Dir eine horizontal waagerechte Linie parallel zur Matratze ergeben. Dazu muss die Matratze ausreichend weich genug sein.');
			} else if (backSleeper) {
				recommendations.push('Als Rückenschläfer sollte diese aus orthopädischen Gründen bei Dir eine natürliche S-Form einnehmen. Die Matratze sollte für Rückenschläfer deswegen weder zu hart, noch zu weich sein.');
			} else if (stomachSleeper) {
				recommendations.push('Als Bauchschläfer sollte diese aus orthopädischen Gründen bei Dir eine natürliche S-Form einnehmen. Die Matratze sollte für Bauchschläfer deswegen nicht zu weich sein.');
			} else if (switchingSleeper) {
				recommendations.push('Als jemand, der häufiger seine Schlafposition wechselt, sollte Dein Körper ausreichend gut gestützt sein. Die Matratze darf weder zu hart noch zu weich sein.');
			}

			recommendations.push('Aufgrund Deines ergonomischen Härtegrad-Indexes ist für eine dauerhaft gesunde Schlafposition unser Härtegrad H3 die richtige Wahl für Dich - insbesondere, weil durch die 7-Zonen eine gute Druckverteilung und gleichzeitig eine ausreichende Flexibilität gewährleistet ist.');

			recommendations.push(...addTendencies(data));

			return recommendations;
		}
		
		if (ergonomicIndexFirmness === 'h4') {
			recommendations.push('Dein Körpergewicht ist im Verhältnis zu Deiner Größe normal bis leicht erhöht. Daher benötigst Du eine eher festere Federung. So werden gewisse Körperpartien ausreichend gestützt, um eine optimale Wirbelsäulenposition zu gewährleisten.');

			if (sideSleeper) {
				recommendations.push('Als Seitenschläfer sollte diese aus orthopädischen Gründen bei Dir eine horizontal waagerechte Linie parallel zur Matratze ergeben. Dazu muss die Matratze ausreichend fest sein.');
			} else if (backSleeper) {
				recommendations.push('Als Rückenschläfer sollte diese aus orthopädischen Gründen bei Dir eine natürliche S-Form einnehmen. Die Matratze sollte für Rückenschläfer daher eher fest sein.');
			} else if (stomachSleeper) {
				recommendations.push('Als Bauchschläfer sollte diese aus orthopädischen Gründen bei Dir eine natürliche S-Form einnehmen. Die Matratze sollte für Bauchschläfer deswegen nicht zu weich sein.');
			} else if (switchingSleeper) {
				recommendations.push('Als jemand, der häufiger seine Schlafposition wechselt, sollte Dein Körper ausreichend gut gestützt sein. Die Matratze sollte daher nicht zu weich sein.');
			}

			recommendations.push('Aufgrund Deines ergonomischen Härtegrad-Indexes ist für eine dauerhaft gesunde Schlafposition unser Härtegrad H4 die richtige Wahl für Dich - insbesondere, weil durch die 7-Zonen eine gute Druckverteilung und gleichzeitig eine ausreichende Flexibilität gewährleistet ist.');

			recommendations.push(...addTendencies(data, [ 'Nackenschmerzen' ]));
		
			return recommendations;
		}

		return recommendations;
	}

	if (bmiFirmness === 'h4') {

		if (ergonomicIndexFirmness === 'h3') {
			recommendations.push('Dein Körpergewicht ist im Verhältnis zu Deiner Größe etwas erhöhter. Daher benötigst Du eine mindestens mittelfeste Federung. So werden bestimmte Körperpartien ausreichend gestützt, um eine optimale Wirbelsäulenposition zu gewährleisten.');

			if (sideSleeper) {
				recommendations.push('Als Seitenschläfer sollte diese aus orthopädischen Gründen bei Dir eine horizontal waagerechte Linie parallel zur Matratze ergeben. Dazu darf die Matratze jedoch nicht zu fest sein.');
			} else if (backSleeper) {
				recommendations.push('Als Rückenschläfer sollte diese aus orthopädischen Gründen bei Dir eine natürliche S-Form einnehmen. Die Matratze sollte für Rückenschläfer daher eher fest sein.');
			} else if (stomachSleeper) {
				recommendations.push('Als Bauchschläfer sollte diese aus orthopädischen Gründen bei Dir eine natürliche S-Form einnehmen. Die Matratze sollte für Bauchschläfer deswegen nicht zu weich sein.');
			} else if (switchingSleeper) {
				recommendations.push('Als jemand, der häufiger seine Schlafposition wechselt, sollte Dein Körper ausreichend gut gestützt sein. Die Matratze sollte daher nicht zu weich sein.');
			}

			recommendations.push('Aufgrund Deines ergonomischen Härtegrad-Indexes ist für eine dauerhaft gesunde Schlafposition unser Härtegrad H3 die richtige Wahl für Dich - insbesondere, weil durch die 7-Zonen eine gute Druckverteilung und gleichzeitig eine ausreichende Flexibilität gewährleistet ist.');

			recommendations.push(...addTendencies(data, [ 'Nackenschmerzen' ])); 
 
			return recommendations;
		}
		
		if (ergonomicIndexFirmness === 'h4') {
			recommendations.push('Dein Körpergewicht ist im Verhältnis zu Deiner Größe erhöhter. Daher benötigst Du eine eher festere Federung. So werden bestimmte Körperpartien ausreichend gestützt, um eine optimale Wirbelsäulenposition zu gewährleisten.');

			if (sideSleeper) {
				recommendations.push('Als Seitenschläfer sollte diese aus orthopädischen Gründen bei Dir eine horizontal waagerechte Linie parallel zur Matratze ergeben. Dazu muss die Matratze fest genug sein.');
			} else if (backSleeper) {
				recommendations.push('Als Rückenschläfer sollte diese aus orthopädischen Gründen bei Dir eine natürliche S-Form einnehmen. Die Matratze sollte für Rückenschläfer daher eher fest sein.');
			} else if (stomachSleeper) {
				recommendations.push('Als Bauchschläfer sollte diese aus orthopädischen Gründen bei Dir eine natürliche S-Form einnehmen. Die Matratze sollte für Bauchschläfer deswegen nicht zu weich sein.');
			} else if (switchingSleeper) {
				recommendations.push('Als jemand, der häufiger seine Schlafposition wechselt, sollte Dein Körper ausreichend gut gestützt sein. Die Matratze sollte daher nicht zu weich sein.');
			}

			recommendations.push('Aufgrund Deines ergonomischen Härtegrad-Indexes ist für eine dauerhaft gesunde Schlafposition unser Härtegrad H4 die richtige Wahl für Dich - insbesondere, weil durch die 7-Zonen eine gute Druckverteilung und gleichzeitig eine ausreichende Festigkeit gewährleistet ist.');

			recommendations.push(...addTendencies(data, [ 'Nackenschmerzen' ]));

			return recommendations;
		}

		return recommendations;
	}

	return recommendations;
}

type TendencyTexts = keyof typeof tendencyTexts;
const tendencyTexts = {
	Schulterschmerzen: 'Schulter- oder Hüftschmerzen können bei Dir {{sleeperType}} dadurch entstehen, dass auf Deine Schulter und/oder Hüfte zu viel Druck lastet, sprich diese nicht tief genug in die Matratze einsinken. Mit unserer 7-Zonen-Matratze mit Härtegrad {{firmness}} werden Schulter und Hüfte tief genug einsinken und dadurch entlastet.',
	get 'Hüftschmerzen' () {
		return this['Schulterschmerzen'];
	},
	Nackenschmerzen: 'Deine Nackenschmerzen können durch eine falsche Schlafposition hervorgerufen werden. Hier ist neben einer guten Matratze insbesondere die Wahl des richtigen Kissens wichtig. {{sleeperTypeText}}',
	Rueckenschmerzen: 'Dass Du häufiger Rückenschmerzen im {{backHurt}} Rücken verzeichnest, kann bei Dir {{sleeperType}} daran liegen, dass die Wirbelsäule im Schlaf falsch gelagert wird. {{sleeperTypeText}} Mit unserer 7-Zonen-Matratze mit Härtegrad {{firmness}} wird Deine Wirbelsäule wieder richtig unterstützt. Deine Schmerzen können dadurch effektiv gelindert werden.',
	'Schwitzen in der Nacht': 'Niemand muss zu starkem Schwitzen in der Nacht neigen. Neben der Bettwäsche besteht bereits bei der Wahl des richtigen Bettes die Möglichkeit, das Schwitzen zu reduzieren. Die doppelte Federkernschicht in jedem Mozart Bett gewährleistet eine optimale Luftzirkulation und transportiert Wärme gut ab. Der wärmeregulierende Topperbezug mit Klimafasern unterstützt den Abtransport überflüssiger Wärme zusätzlich.',
	Milbenallergien: 'Um Deiner Milbenallergie den Wind aus den Segeln zu nehmen, ist jedes Mozart Bett durch zwei echte Federkernschichten für ausreichende Luftzirkulation optimiert. Der allergikerfreundliche Topperbezug bietet von Haus aus einen intergrierten Milbenschutz. Damit können Milben nicht in das Bett eindringen. Allergische Symptome können dadurch stark eingedämmt werden. Ein zusätzliches Matratzen-Encasing wird nicht mehr benötigt.',
}

function getTendencyText (tendency: TendencyTexts, replacers: Record<string, string> = {}) {
	return tendencyTexts[tendency].replace(/{{(\w+)}}/g, (match, key) => replacers[key]);;
}

function addTendencies (data: UserData, excludeTendencies: string[] = []) {
	const { sleepPosition, tendencies } = data;

	if (!tendencies || tendencies.length < 1) {
		return [];
	}

	const result: string[] = [];
	const addedTendencies: string[] = [];

	const backSleeper = sleepPosition === 'auf dem Rücken',
		sideSleeper = sleepPosition === 'auf der Seite',
		stomachSleeper = sleepPosition === 'auf dem Bauch',
		switchingSleeper = sleepPosition === 'häufig wechselnd',
		dontKnowSleeper = sleepPosition === 'Weiß ich nicht genau';

	const sleeperType = backSleeper ? 'Rückenschläfer' :
		(sideSleeper ? 'Seitenschläfer' :
		(stomachSleeper ? 'Bauchschläfer' :
		(switchingSleeper ? 'mit häufig wechselnder Schlafposition' : '')));

	for (const tendency of tendencies) {

		if (excludeTendencies.includes(tendency)) {
			continue;
		}

		if (addedTendencies.includes(tendency)) {
			continue;
		}

		if (tendency === 'Schulterschmerzen' || tendency === 'Hüftschmerzen') {
			if (addedTendencies.includes('Schulterschmerzen') || addedTendencies.includes('Hüftschmerzen')) {
				continue;
			}

			result.push(
				getTendencyText('Schulterschmerzen', {
					sleeperType: `${!switchingSleeper && !dontKnowSleeper ? 'als ' : ''}${sleeperType}`,
					firmness: data.firmness.substring(1),
				})
			);
		} else if (tendency === 'Nackenschmerzen') {
			let text = '';
	
			if (stomachSleeper) {
				text = 'Als Bauchschläfer sollte Dein Kissen eher flach sein, damit der Nacken nicht übermäßig gespannt wird.';
			} else if (backSleeper) {
				text = 'Als Rückenschläfer benötigst Du ein mittelhohes Kissen, um den Nacken während des Schlafs zu entlasten.';
			} else if (sideSleeper) {
				text = 'Als Seitenschläfer benötigst Du ein etwas dickeres Kissen, dass die Lücke zwischen Kopf und Schultern optimal ausfüllt und dadurch den Nacken entlastet.';
			} else if (switchingSleeper) {
				text = 'Als jemand, der häufig seine Schlafposition wechselt, benötigst Du ein flexibel einsetzbares Kissen. Hier empfehlen sich insbesondere länglichere Kissen (z.B. 80x40 cm).';
			} else if (dontKnowSleeper) {
				text = 'Als jemand, der seine Schlafposition nicht genau kennt, benötigst Du ein flexibel einsetzbares Kissen. Hier empfehlen sich insbesondere länglichere Kissen (z.B. 80x40 cm).';
			}
	
			if (text) {
				result.push(
					getTendencyText('Nackenschmerzen', {
						sleeperTypeText: text,
					})
				);
			}
		} else if (tendency === 'Rückenschmerzen (ganzer Rücken)' || tendency === 'Rückenschmerzen (unterer Rücken)') {
			if (addedTendencies.includes('Rückenschmerzen (ganzer Rücken)') || addedTendencies.includes('Rückenschmerzen (unterer Rücken)')) {
				continue;
			}

			const hurtsLower = tendency === 'Rückenschmerzen (unterer Rücken)';
	
			const sleeperTypeText = (
					backSleeper ? 'Rückenschläfer schlafen häufig zu weich oder auf durchgelegenen Matratzen.' : (
						sideSleeper ? 'Seitenschläfer schlafen häufig zu hart.' :
						stomachSleeper ? 'Bauchschläfer schlafen häufig zu weich oder auf durchgelegenen Matratzen.' :
						''
					)
				);
	
			result.push(
				getTendencyText('Rueckenschmerzen', {
					backHurt: hurtsLower ? 'unteren' : 'ganzen',
					sleeperType: switchingSleeper || dontKnowSleeper ? '' : `als ${sleeperType}`,
					sleeperTypeText,
					firmness: data.firmness.substring(1),
				})
			);
	
		} else if (tendency === 'Schwitzen in der Nacht') {
			result.push(
				getTendencyText('Schwitzen in der Nacht')
			);
		} else if (tendency === 'Milbenallergien') {
			result.push(
				getTendencyText('Milbenallergien')
			);
		}

		addedTendencies.push(tendency);
	}

	return result;
}



export function getTopperRecommendation (data: Data, partner = false): 'Gel Topper' | 'Kaltschaum' | 'PurGel-Topper' {
	const userData = partner ? data.partner! : data.you;
	const store = useStore();

	if (userData.ownFirmness === 'eher festes Liegegefühl') {
		return 'Kaltschaum';
	}

	if (userData.ownFirmness === 'keine Präferenz / Weiß nicht' && !partner && data.partner) {
		return getTopperRecommendation(data, true);
	}

	if (store && store.attributes.series === 'mozart9') {
		return 'PurGel-Topper';
	}

	return 'Gel Topper';
}
